import {Injectable} from '@angular/core';


@Injectable()
export class UtilsService {

  public static sortModules(modules: any[]): any[] {
    return modules.sort(((a, b) => (a.seder || 0) - (b.seder || 0)))
  }

  daydiff(first, second) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24));
  }

  queryStringToObj(query: string) {
    if (!query) {
      return {};
    }
    const qd = {};
    query.split('?').pop().split(`&`).forEach(item => {
      const [k, v] = item.split(`=`);
      qd[k] = v && decodeURIComponent(v);
    });
    return qd;
  }

  standardEncoding(v: string): string {
    return v
      .replace(/%40/gi, '@')
      .replace(/%3A/gi, ':')
      .replace(/%24/gi, '$')
      .replace(/%2C/gi, ',')
      .replace(/%3B/gi, ';')
      .replace(/%2B/gi, '+')
      .replace(/%3D/gi, '=')
      .replace(/%3F/gi, '?')
      .replace(/%2F/gi, '/');
  }

  serializeObj(obj) {
    let str = '';
    for (const field of Object.keys(obj)) {
      if (obj[field] !== '') {
        str += '&' + field + '=' + (obj[field]);
      }
    }
    return str;
  }

  stringToIntIfIsInt(value: any) {
    return isNaN(value) ? value : Number(value);
  }

  utf8ToB64(str) {
    return btoa(unescape(encodeURIComponent(str)));
  }

  b64ToUtf8(str) {
    return decodeURIComponent(escape(atob(str)));
  }
}
